export default "__VITE_ASSET__BP7$pdrR__"